/**
 * What a carrier dictates, so a client adding their own trunk picks a carrier and types a login
 * (owner, 26 September 2026: "adding a trunk on a clients side didn't go well. It needs to be
 * easier").
 *
 * Only carriers whose settings are PROVEN: Switch Tel from our own trunk, registered since
 * 11 September; Afrihost from its phone set-up guide (host, the VoIP number as username and caller
 * ID) and a client trunk registered on 26 September. Anything else is Other, asked for in full --
 * a preset built from a guess is worse than the form, because nobody checks it.
 */

export interface CarrierPreset {
  key: string;
  label: string;
  hint: string;
  host: string;
  port: number;
  transport: 'udp' | 'tcp';
  auth_mode: 'register' | 'digest';
  /** Null: the host is the realm. */
  realm: string | null;
  outbound_format: 'e164' | 'e164_no_plus' | 'national' | '00_prefixed';
  codecs: string[];
  /** What the carrier calls the username, as its welcome email says it. */
  username_label: string;
  username_hint: string;
  /** The username is the account's phone number, so it is the caller ID too. */
  username_is_number: boolean;
}

export const CARRIER_PRESETS: CarrierPreset[] = [
  {
    key: 'afrihost', label: 'Afrihost', hint: 'Afrihost VoIP / Pure VoIP',
    host: 'sip.afrihost.com', port: 5060, transport: 'udp', auth_mode: 'register', realm: null,
    // Afrihost publishes no dial format; its phones send numbers as dialled (0…), which is national.
    outbound_format: 'national', codecs: ['PCMA', 'PCMU'],
    username_label: 'VoIP number', username_hint: 'As in your Afrihost welcome email, e.g. 0872650584',
    username_is_number: true,
  },
  {
    key: 'switchtel', label: 'Switch Tel', hint: 'Switch Telecom SIP account',
    host: 'sip.switchtel.co.za', port: 5060, transport: 'udp', auth_mode: 'register', realm: 'switchtel.co.za',
    outbound_format: 'national', codecs: ['PCMA'],
    username_label: 'SIP username', username_hint: 'Your Switch Tel account number, e.g. 0105025383',
    username_is_number: true,
  },
];

/** "087 265 0584" or "+27 87 265 0584" -> "+27872650584"; null when it is not a phone number. */
export function toE164(raw: string, countryCode = '27'): string | null {
  const s = raw.trim();
  let d = s.replace(/\D/g, '');
  if (!d) return null;
  if (s.startsWith('+')) { /* already international */ }
  else if (d.startsWith('00')) d = d.slice(2);
  else if (d.startsWith('0')) d = countryCode + d.slice(1);
  return d.length >= 8 && d.length <= 15 ? `+${d}` : null;
}
